import {kAppStoreUrl, kGooglePlayUrl} from 'config';

import {getOS, openInNewTab} from './common';

/**
 * openMobileStore
 * @returns
 */
export const openMobileStore = () => {
  const os = getOS();
  return openInNewTab(['iPhone', 'Mac'].includes(os) ? kAppStoreUrl : kGooglePlayUrl);
};

export const isSafari = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('safari') && !userAgent.includes('chrome');
};
